import { styled } from "@mui/material";
import { FormFooter as TidalFormFooter } from "../../form/index.js";
const FormFooter = styled(TidalFormFooter)(({ theme: { spacing } }) => ({
  "--form-footer-padding": 0,
  marginTop: spacing(2)
}));
export {
  FormFooter
};
//# sourceMappingURL=FormFooter.js.map
